import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import {
    PrimaryButton,
    Panel,
    PanelType,
    Separator,
    Stack,
    Checkbox,
} from '@fluentui/react';
import { TRANSLATION_KEYS } from './localization/translation-keys';
import { ITicketColumn } from '../IAITable/IAIDetailsList/iai-details-list';

interface IIAIColumnsRefinementDrawer {
    disabled?: boolean;
    drawerVisible?: boolean;
    columns: ITicketColumn[];
    onApplyCriteria: (columns: ITicketColumn[]) => void;
    onClearCriteria?: () => void;
    onDrawerDismiss: () => void;
}

const IAIColumnsRefinementDrawer: React.FunctionComponent<IIAIColumnsRefinementDrawer> = ({
    disabled,
    drawerVisible,
    columns,
    onApplyCriteria,
    onClearCriteria,
    onDrawerDismiss,
}) => {
    //#region Dropdown-Management
    const [selected, setSelected] = useState<ITicketColumn[]>([]);
    //#endregion

    useEffect(() => {
        setSelected(columns);
    }, [columns]);

    const {
        t: translate
    } = useTranslation();

    return (
        <Panel
            type={PanelType.smallFixedFar}
            headerText={translate(TRANSLATION_KEYS.Heading)}
            isOpen={drawerVisible}
            isBlocking={true}
            isFooterAtBottom={true}
            onDismiss={onDrawerDismiss}
            onRenderFooterContent={() => (
                <div className="text-end">
                    <PrimaryButton
                        type="submit"
                        disabled={disabled}
                        onClick={() => {
                            onApplyCriteria(selected);
                        }}
                    >
                        {translate(TRANSLATION_KEYS.ConfirmText)}
                    </PrimaryButton>
                </div >
            )}
        >
            <Separator />
            <Stack tokens={{ childrenGap: 15 }}>
                {columns.filter(x => !x.isLocked).map((column, index) => {
                    return (
                        <Checkbox
                            key={`${column.key}-${index}`}
                            name="defaultRender"
                            label={column.name}
                            checked={!!selected.find(x => x === selected.find(x => x.key === column.key))?.isActive}
                            onChange={(_ev, checked) => {
                                setSelected(prev => {
                                    return [...prev.map(x => {
                                        if (x.key === column.key) {
                                            return { ...x, isActive: checked }
                                        }

                                        return x;
                                    })];
                                });
                            }}
                        />
                    )
                })}
            </Stack>
        </Panel >
    );
}

export default IAIColumnsRefinementDrawer;